module.exports = __webpack_public_path__ + "media/35.fca2a18a.mp3";